import styled from 'styled-components';

// @source
import { theme } from '../../styles';

export const ExcelViewer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding-top: 43px;
  overflow: auto;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 999;

  table {
    width: auto;
    min-width: 100%;
  }

  td, th {
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid ${theme.border};

    &:first-child {
      padding-left: 8px;
      border-left-width: 0;
    }

    &:last-child {
      padding-right: 8px;
      border-right-width: 0;
    }
  }
`;

export const ExcelButtonGroup = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 500;
`;

export const SpinnerColumns = styled.div`
  margin: 1.5rem 0;
  padding: 24px 0;
  text-align: center;
`;

export const ButtonGroup = styled.div`
  margin-top: 1rem;
  position: relative;
`;
